module.exports = __webpack_public_path__ + "img/426-b3f501.png";